<template>
  <div>
    <van-sticky :offset-top="46">
      <van-search
        v-model="queryParams.productName"
        shape="round"
        show-action
        background="#4fc08d"
        clearable
        placeholder="请输入搜索关键词"
      >
        <template #action>
          <div style="padding: 0px 4px;" @click="handleRefresh">搜索</div>
        </template>
      </van-search>
    </van-sticky>
    <page-list ref='pageList' request-url="/stock/list" :getParams="getQueryParams">
      <template #row="{row}">
        <div style="background-color:rgba(172,201,220,0.19);line-height: 32px;border-radius: 6px;padding: 6px 10px">
          <van-row>
            <van-col span="24">商品: {{row.productName}}</van-col>
          </van-row>
          <van-row >
            <van-col span="12">最新库存: <span style="font-weight: 500;font-size: 20px;color: #07c160">{{row.quantity}}</span> ({{row.unit}})</van-col>
            <van-col span="12">最新采购价: <span style="font-weight: 500;font-size: 20px;color: #f5222d">{{row.latestPurchasePrice}}</span></van-col>
          </van-row>
          <van-row>
            <van-col span="12">耗损数量: {{row.scrapQuantity}} ({{row.unit}})</van-col>
            <van-col span="12">销售数量: {{row.saleQuantity}} ({{row.unit}})</van-col>
            <van-col span="12">历史总量: {{row.totalQuantity}} ({{row.unit}})</van-col>
          </van-row>
          <van-row>
            <van-col span="12">成本价: {{row.price}}</van-col>
            <van-col span="12">总价值: {{row.totalAmount}}</van-col>
          </van-row>
            <van-row type="flex" justify="center" >
              <van-col span="8"><van-button type="default" size="small" block @click="openInDrawer(row)">入库</van-button></van-col>
              <van-col span="8"><van-button type="info" size="small" block @click="openOutDrawer(row)">出库</van-button></van-col>
              <van-col span="8"><van-button type="default" size="small" block @click="openScrapDrawer(row)">耗损</van-button></van-col>
            </van-row>
        </div>
      </template>
    </page-list>
    <down-drawer ref='inputDrawer' @close="handleRefresh" @confirm="onInStock" title="采购入库" >
      <template #content>
        <van-form ref="inForm" :validate-first="true" :show-error-message="false">
          <van-field
            readonly
            clickable
            name="productName"
            v-model="model.productName"
            label="商品名称"
            placeholder="商品名称"
          />
          <van-field
            readonly
            clickable
            name="purchaseDate"
            v-model="model.purchaseDate"
            label="采购日期"
            placeholder="点击选择日期"
            @click="purchaseDateShow = true"
          />
          <van-field
            name="purchaseQuantity"
            label="采购数量"
            :rules="[{ required: true, message: '采购数量不能为空' }]">
            <template #input>
              <van-stepper v-model="model.purchaseQuantity" step="0.1" :decimal-length="2" :input-width ='64' :min="0.1" />
            </template>
          </van-field>
          <van-field
            name="purchaseAmount"
            label="采购金额"
            :rules="[{ required: true, message: '采购金额不能为空' }]">
            <template #input>
              <van-stepper v-model="model.purchaseAmount" step="0.1" :decimal-length="2" :input-width ='64' :min="0.1" />
            </template>
          </van-field>
          <van-field
            readonly
            clickable
            name="purchaseMode"
            v-model="model.purchaseMode"
            label="采购模式"
            placeholder="点击采购模式"
            @click="purchaseModeShow = true"
          />
          <van-field
            name="remark"
            v-model="model.remark"
            label="备注"
            type="textarea"
            maxlength="50"
            placeholder="请输入备注"
            show-word-limit>
          </van-field>
        </van-form>
      </template>
    </down-drawer>
    <down-drawer ref='adjustDrawer' @close="handleRefresh" @confirm="onOutStock" title="销售出库" >
      <template #content>
        <van-form ref="form" :validate-first="true" :show-error-message="false">
          <van-field
            name="stockQuantity"
            label="库存数量"
            input-align ='right'
            :rules="[{ required: true, message: '库存数量不能为空' }]">
            <template #input>
              <van-stepper v-model="model.stockQuantity" step="0.1" :decimal-length="2" :input-width ='64' :min="0.1" />
            </template>
          </van-field>
          <van-field
            name="outRemark"
            v-model="model.outRemark"
            label="备注"
            type="textarea"
            maxlength="50"
            placeholder="请输入备注"
            show-word-limit
            input-align ='right'>
          </van-field>
        </van-form>
      </template>
    </down-drawer>
    <down-drawer ref='scrapDrawer' @close="handleRefresh" @confirm="onScrapStock" title="追加耗损" >
      <template #content>
        <van-form ref="scrapForm" :validate-first="true" :show-error-message="false">
          <van-field
            name="scrapQuantity"
            label="耗损数量"
            input-align ='right'
            :rules="[{ required: true, message: '耗损数量不能为空' }]">
            <template #input>
              <van-stepper v-model="model.scrapQuantity" step="0.1" :decimal-length="2" :input-width ='64' :min="0.1"/>
            </template>
          </van-field>
          <van-field
            name="scrapRemark"
            v-model="model.scrapRemark"
            label="备注"
            type="textarea"
            maxlength="50"
            placeholder="请输入备注"
            show-word-limit
            input-align ='right'>
          </van-field>
        </van-form>
      </template>
    </down-drawer>
    <van-calendar v-model="purchaseDateShow" :show-confirm="false" :min-date= "minDate" @confirm="onPurchaseDateConfirm" :style="{ height: '500px' }"/>
    <van-popup v-model="purchaseModeShow" position="bottom">
      <van-picker
        show-toolbar
        :columns="purchaseModeOptions"
        @confirm="purchaseModeConfirm"
        @cancel="purchaseModeShow = false"
      />
    </van-popup>
  </div>
</template>

<script>
import PageList from '@/components/tools/PageList'
export default {
  name: 'OrderList',
  components: { PageList },
  created () {
    this.queryParams.deliveryDate = this.$moment(new Date()).format('YYYY-MM-DD')
    this.purchaseDay = this.$moment(new Date()).format('YYYY-MM-DD')
  },
  data () {
    const that = this
    return {
      url: {
        imgerver: window._CONFIG.staticDomainUrl
      },
      purchaseModeOptions: [
        { text: '集采', value: '01' },
        { text: '临采', value: '02' }
      ],
      show: false,
      purchaseDateShow: false,
      purchaseModeShow: false,
      allOrder: false,
      model: {},
      queryParams: {
        productName: null
      },
      minDate: new Date(that.$moment(new Date()).subtract(3, 'months').startOf('month').format('YYYY-MM-DD'))
    }
  },
  computed: {

  },
  methods: {
    purchaseModeConfirm (value) {
      this.purchaseModeShow = false
      this.model.purchaseMode = value.text
    },
    onPurchaseDateConfirm (date) {
      this.purchaseDateShow = false
      this.model.purchaseDate = this.$moment(date).format('YYYY-MM-DD')
    },
    getQueryParams (params) {
      const param = Object.assign({}, params)
      param.productName = this.queryParams.productName
      return { params: param }
    },
    handleRefresh () {
      this.$refs.pageList.onRefresh(20, false)
    },
    openInDrawer (row) {
      this.model = {}
      this.model.id = row.id
      this.model.productName = row.productName
      this.model.unit = row.unit
      this.$set(this.model, 'purchaseAmount', 0.1)
      this.$set(this.model, 'purchaseQuantity', 0.1)
      this.$set(this.model, 'purchaseMode', '集采')
      this.$set(this.model, 'remark', '')
      this.$set(this.model, 'purchaseDate', this.$moment(new Date()).format('YYYY-MM-DD'))
      // this.model.chargeAmount = 0
      this.$refs.inputDrawer.show = true
    },
    onInStock () {
      // 触发表单验证
      this.$refs.inForm.validate().then(() => {
        let mode = '01'
        this.purchaseModeOptions.forEach(item => {
          if (item.text === this.model.purchaseMode) {
            mode = item.value
          }
        })
        this.$api.shop.inStock(this.model.id,
          {
            productId: this.model.id,
            productName: this.model.productName,
            unit: this.model.unit,
            purchaseDate: this.model.purchaseDate,
            purchaseAmount: this.model.purchaseAmount,
            purchaseQuantity: this.model.purchaseQuantity,
            purchaseMode: mode,
            remark: this.model.remark
          }).then(response => {
          if (response.success) {
            this.$toast.success('入库成功')
          } else {
            this.$toast.fail(response.message)
          }
          this.$refs.inputDrawer.show = false
          this.handleRefresh()
        }).catch(() => {
        })
      }).catch((err) => {
        console.log('验证失败', err)
      })
    },
    openOutDrawer (row) {
      this.model = {}
      this.model.id = row.id
      this.$set(this.model, 'stockQuantity', 0.1)
      this.$set(this.model, 'outRemark', '')
      // this.model.chargeAmount = 0
      this.$refs.adjustDrawer.show = true
    },
    onOutStock () {
      // 触发表单验证
      this.$refs.form.validate().then(() => {
        this.$api.shop.outStock(this.model.id,
          { quantity: this.model.stockQuantity, remark: this.model.outRemark }).then(response => {
          if (response.success) {
            this.$toast.success('出库成功')
          } else {
            this.$toast.fail(response.message)
          }
          this.$refs.adjustDrawer.show = false
          this.handleRefresh()
        }).catch(() => {
        })
      }).catch((err) => {
        console.log('验证失败', err)
      })
    },
    openScrapDrawer (row) {
      this.model = {}
      this.model.id = row.id
      this.$set(this.model, 'scrapQuantity', 0.1)
      this.$set(this.model, 'scrapRemark', '')
      this.$refs.scrapDrawer.show = true
    },
    onScrapStock () {
      // 触发表单验证
      this.$refs.scrapForm.validate().then(() => {
        this.$api.shop.scrapStock(this.model.id,
          { quantity: this.model.scrapQuantity, remark: this.model.scrapRemark }).then(response => {
          if (response.success) {
            this.$toast.success('操作成功')
          } else {
            this.$toast.fail(response.message)
          }
          this.$refs.scrapDrawer.show = false
          this.handleRefresh()
        }).catch(() => {
        })
      }).catch((err) => {
        console.log('验证失败', err)
      })
    }
  }

}
</script>

<style lang="less" scoped>
  .avatar{
    width: 84px;
    height: 84px;
    vertical-align: middle;
    padding: 8px 0px;
    border-radius: 50%;
  }
</style>
